import { privateApi } from './index';

export const getDrivers = () =>
  privateApi.get('/users');

export const getDriverDetail = (uuid : any) =>
  privateApi.get('/users/' + uuid);

export const setStatus = (data: any) =>
  privateApi.post('/users/status', data);

export const upsertDriver = (data : any) =>
  privateApi.post('/drivers', data);